<template>
	<router-view
		:horse_id="horse_id"
	></router-view>
</template>

<script>
export default {
	name: 'Stallion',
	props: ['horse_id'],
	mounted() {
		this.init_component()
	},

	methods: {
		async init_component() {
			this.$router.push({ name: 'StallionDashboard' })
		}
	}
}
</script>
